import React from 'react';
import { List, ListItem, ListItemText } from '@mui/material';

// Shared bulleted-list styling for legal pages (Privacy Policy, Terms and
// Conditions, and any future policy pages) — one place to keep list
// appearance consistent, rather than each page redefining its own.
const BulletList = ({ items }) => (
  <List sx={{ listStyleType: 'disc', pl: 3, py: 0 }}>
    {items.map((item, index) => (
      <ListItem key={index} sx={{ display: 'list-item', pl: 0, py: 0.5 }}>
        <ListItemText primary={item} />
      </ListItem>
    ))}
  </List>
);

export default BulletList;
